import {
  COOKIES_ACCEPT_COOKIE_NAME,
  COOKIE_MAX_AGE,
} from '@/shared/constants/cookiesConstants';
import { ROOT_HELPER_URL } from '@/shared/constants/urlConstants';
import type { UseCookiesPanelReturn } from '@/widgets/CookiesPanel/model/types/cookiesPanel';

export const useCookiesPanel = (): UseCookiesPanelReturn => {
  const route = useRoute();
  const cookiesAccepted = useCookie<boolean | null>(COOKIES_ACCEPT_COOKIE_NAME, {
    path: '/',
    maxAge: COOKIE_MAX_AGE,
  });

  const isHelperPage: ComputedRef<boolean> = computed(() =>
    route.path.startsWith(ROOT_HELPER_URL),
  );

  const isShowCookiesPanel: ComputedRef<boolean> = computed(
    () => !cookiesAccepted.value && !isHelperPage.value,
  );

  const acceptCookies = (): void => {
    cookiesAccepted.value = true;
  };

  return { isShowCookiesPanel, acceptCookies };
};
